import Vue from 'vue';
import Router from 'vue-router';
//import Store from './vuex/store.js'
import { is_authenticated } from '@/utilities';

Vue.use(Router);

let router = new Router({
  mode: process.env.VUE_APP_ROUTER_MODE,
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'homepage',
      //is_private: false, //custom attribute
      component: () =>
        import('./components/views/homepage').then(function (Homepage) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: Homepage View loaded');
          return Homepage;
        }),
    },
    {
      path: '/results',
      name: 'results',
      //is_private: false, //custom attribute
      component: () =>
        import('./components/views/results').then(function (Results) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: Results View loaded');
          return Results;
        }),
    },
    {
      path: '/detail',
      name: 'detail',
      //is_private: false, //custom attribute
      props: true,
      component: () =>
        import('./components/views/detail').then(function (Detail) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: Detail View loaded');
          return Detail;
        }),
    },
    {
      path: '/checkout',
      name: 'checkout',
      //is_private: false, //custom attribute
      props: true,
      component: () =>
        import('./components/views/checkout').then(function (Checkout) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: Checkout View loaded');
          return Checkout;
        }),
    },
    {
      path: '/seat-selection',
      name: 'seat-selection',
      props: true,
      component: () =>
        import('./components/views/seat-selection').then(function (SeatSelector) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: Checkout View loaded');
          return SeatSelector;
        }),
    },
    {
      path: '/confirm/:flight_voucher_id/:confirm_code',
      name: 'confirm',
      //is_private: false, //custom attribute
      component: () =>
        import('./components/views/confirm').then(function (Confirm) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: Confirm View loaded');
          return Confirm;
        }),
      props: (route) => {
        return {
          confirm_code: route.params.confirm_code,
          flight_voucher_id: route.params.flight_voucher_id,
          ignore_redirect: false,
        };
      },
    },
    {
      path: '/prenotazioni/:flight_voucher_id/:confirm_code',
      name: 'prenotazioni',
      //is_private: false, //custom attribute
      component: () =>
        import('./components/views/confirm').then(function (Confirm) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: Confirm View loaded');
          return Confirm;
        }),
      props: (route) => {
        return {
          confirm_code: route.params.confirm_code,
          flight_voucher_id: route.params.flight_voucher_id,
          ignore_redirect: true,
        };
      },
    },
    {
      path: '/termini-e-condizioni',
      name: 'terms',
      //publicRoute: false, //custom attribute
      component: () =>
        import('./components/views/terms').then(function (Terms) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: Terms View loaded');
          return Terms;
        }),
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      beforeEnter() {
        location.href = 'https://www.iubenda.com/privacy-policy/32772449';
      },
      publicRoute: true, //custom attribute
    },
    {
      path: '/chi-siamo',
      name: 'about',
      //publicRoute: false, //custom attribute
      component: () =>
        import('./components/views/about').then(function (About) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: About View loaded');
          return About;
        }),
    },
    {
      path: '/ho-un-buono',
      name: 'dc-sso',
      component: () =>
        import('./components/views/dc-sso').then(function (DcSso) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: DcSso View loaded');
          return DcSso;
        }),
      publicRoute: true, //custom attribute
    },
    {
      path: '/ho-un-buono/:discount_code_url',
      name: 'dc-sso-fields',
      component: () =>
        import('./components/views/dc-sso').then(function (DcSso) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: DcSso View loaded');
          return DcSso;
        }),
      props: true,
      publicRoute: true, //custom attribute
    },
    {
      path: '/ho-un-buono/:discount_code_url/:name_url/:surname_url/:email_url',
      name: 'dc-sso-fields',
      component: () =>
        import('./components/views/dc-sso').then(function (DcSso) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: DcSso View loaded');
          return DcSso;
        }),
      props: true,
      publicRoute: true, //custom attribute
    },
    {
      path: '/paga/:pay_code/:payment_link_id',
      name: 'payments-link',
      props: true,
      component: () =>
        import('./components/views/payments-link').then((PaymentsLink) => {
          return PaymentsLink;
        }),
    },
    {
      path: '/jp-sso',
      name: 'jp-sso',
      component: () =>
        import('./components/views/jp-sso').then(function (JpSso) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: JpSso View loaded');
          return JpSso;
        }),
      publicRoute: true, //custom attribute
    },
    {
      path: '/jp-checkout',
      name: 'jp-checkout',
      component: () =>
        import('./components/views/jp-checkout').then(function (JpCheckout) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: JpCheckout View loaded');
          return JpCheckout;
        }),
      publicRoute: true, //custom attribute
    },
    {
      path: '/error',
      name: 'error',
      component: () =>
        import('./components/views/error').then(function (Error) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: Error View loaded');
          return Error;
        }),
      publicRoute: true, //custom attribute
    },
    {
      path: '/notifications',
      name: 'notifications',
      //publicRoute: false, //custom attribute
      component: () =>
        import('./components/views/notifications').then(function (Notifications) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: Notifications View loaded');
          return Notifications;
        }),
    },
    // gestisce i "404", !!! DEVE STARE PER ULTIMA !!!
    {
      path: '*',
      name: 'not-found',
      component: () =>
        import('./components/views/not-found').then(function (NotFound) {
          if (process.env.VUE_APP_MODE != 'production')
            window.console.log('async: NotFound View loaded');
          return NotFound;
        }),
      props: {
        prerenderStatusCode: '404',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  (to, from, next);

  window.scrollTo(0, 0);

  next();
  return;
});

router.afterEach((to) => {
  // quando torno indietro con history back, nella home ci sono molti componenti caricati in modo asincrono: il browser "ricorda" che deve tornare indietro a (esempio) 1500px di scroll verticale, e lo fa

  if (to.name == 'homepage' && is_authenticated()) {
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 100);
  }

  // per scrollare alle sezioni di id #id
  // bisogna gestirlo in parte manualmente
  // se hai già il sito caricato, i fragment funzionano
  // ma se arrivi da fuori con link con fragment, va gestito così
  if (to.hash && to.hash != '') {
    if (process.env.VUE_APP_MODE != 'production') window.console.log('fragment found');

    setTimeout(function () {
      if (process.env.VUE_APP_MODE != 'production') window.console.log('scrolling to ' + to.hash);
      document.getElementById(to.hash.substr(1)).scrollIntoView();
    }, 1000);
  }
});

export default router;
